import { hasPermissions } from './permissionsHelper';

const ROLE_HOME_ROUTES = {
  doctor: {
    path: 'dashboard',
  },
  assistant: {
    path: 'dashboard',
    permissions: ['conversation_participating_manage'],
  },
  patient_coordinator: {
    path: 'clinical-crm?tab=pipeline',
    permissions: ['crm_manage'],
    feature: 'crm',
  },
  clinical_coordinator: {
    path: 'clinical-crm?tab=pipeline',
    permissions: ['crm_clinical_manage'],
    feature: 'crm',
  },
};

export const getRoleHomePath = (account, permissions = []) => {
  const roleHome = ROLE_HOME_ROUTES[account?.role_template];
  if (!roleHome) return null;
  if (roleHome.feature && !account.features?.[roleHome.feature]) return null;
  if (
    roleHome.permissions &&
    !hasPermissions(roleHome.permissions, permissions)
  ) {
    return null;
  }

  return roleHome.path;
};

export const getAccountHomePath = account =>
  getRoleHomePath(account, account?.permissions) || 'dashboard';

export const getAccountHomeUrl = account => {
  if (!account?.id) throw new TypeError('Account id is required');
  return `/app/accounts/${account.id}/${getAccountHomePath(account)}`;
};
